<script>
    import { onMount } from "svelte";

    import AlertType from "../../Alerts/AlertType";

    import AviationAlertsStore from "../../Aviation/AviationAlertsStore";
    import IconMode from "../../Map/Enums/IconMode";
    import KeyComponent from "./KeyComponent.svelte";

    let mode = AviationAlertsStore.iconMode;

    let availableModes = [];

    export let defaultModeName = "Alert Type";
    export let disabled = false;

	$: {
		availableModes = [
            IconMode.AVIATION_ALERT,
            IconMode.AVIATION_SIL,
            IconMode.AVIATION_NACP,
            // IconMode.TIME_DIFFERENCE,
            IconMode.INDEX
        ];
	};


</script>

<KeyComponent title={"Aircraft Icons"} mode={mode} iconType={"aircraft"} defaultModeName={defaultModeName} availableModes={availableModes} disabled={disabled} />
